import {useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {useNavigate} from 'react-router';

import FormError from 'components/form/Error';
import FormSubmit from 'components/form/Submit';
import FormText from 'components/form/Text';
import {handleSubmitErrors} from 'components/form/utils';
import useAppContext from 'conf/AppContext';

import './Register.scss';


export default function RegisterPage() {
  const appContext = useAppContext();
  const [message, setMessage] = useState(null);

  const formMethods = useForm({
    defaultValues: {
      firstName: '',
      lastName: '',
      email: '',
      password: '',
    },
  });

  const {handleSubmit, setError} = formMethods;

  const onSubmit = async (values) => {
    try {
      const rez = await appContext.api.post('api/v1/users/register', {
        json: values,
        parseJson: true,
      });
      setMessage(rez.message);
    } catch (err) {
      await handleSubmitErrors(appContext, err, setError);
    }
  };


  return (
    <div className="registerPage">
      <FormProvider {...formMethods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <h3 className="text-center mb-5">Create your account</h3>
          {message && <h4 className="text-success text-center mb-3">{message}</h4>}
          <FormText
            label="First name"
            name="firstName"
            required={true}
            className="my-custom-input mb-3"
          />
          <FormText
            label="Last name"
            name="lastName"
            required={true}
            className="my-custom-input mb-3"
          />
          <FormText
            label="Email address"
            name="email"
            required={true}
            className="my-custom-input mb-3"
          />
          <FormText
            label="Password"
            name="password"
            required={true}
            type="password"
            className="my-custom-input mb-3"
          />

          <div className="text-center mt-3">
            <FormError />
            <FormSubmit
              key="save"
              className="btn btn-lg btn-outline-light bg-black text-white"
            >
              Get Registration Link
            </FormSubmit>
          </div>
        </form>
      </FormProvider>
    </div>
  );
}
